import { api } from "../../app/api.js";
import { store } from "../../app/store.js";
import { secondsToTime } from "../../helpers/time.js";

export default {
    template: `
        <div id="vod-unauthorised" class="hidden">
            <div class="section">
                <h1>VOD</h1>
                <h2>Re-watch past radio shows</h2>
                <p class="center">
                    Subscribe and get access to our recorded radio shows from the past month.<br/>
                    Replay the sessions anytime roots on demand whenever you feel the need.
                </p>
                <div class="buttons center">
                    <a href="/subscriptions"><button id="SubscribeButton">Find out more</button></a>
                </div>
            </div>
        </div>

        <div id="vod-authorised" class="hidden">
            <div id="vod-player" class="video-layout hidden">
                <div class="video-wrapper">
                    <div id="video-slot" class="video-container">
                        <p class="loading-placeholder">Loading video...</p>
                    </div>
                </div>
            </div>

            <div class="section">
                <h2>Shows</h2>
                <div id="vod-playlist" class="playlist">
                    <p class="center loading">Loading playlist...</p>
                </div>
            </div>
        </div>
    `,

    authorised: false,
    videos: [],
    $unauthorised: null,
    $authorised: null,
    $playlist: null,

    render_playlist() {
        if (this.videos.length === 0) {
            this.$playlist.innerHTML = '<p class="center">No videos available at the moment.</p>';
            return;
        }

        let playlist_position = 0;

        this.$playlist.innerHTML = '';
        this.videos.forEach((video, index) => {
            video.service = 'vod';

            const item = document.createElement('div');
            item.className = 'video';
            item.dataset.position = (playlist_position++).toString();

            if (index === 0) item.classList.add('active');

            // let thumbnail_url = 'public/assets/images/videos/default-thumbnail.png';
            // if (video.thumbnail_url) thumbnail_url = video.thumbnail_url;
            //
            // let thumbnail = '<img src="' + thumbnail_url + '" alt="Thumbnail" class="thumbnail">'
            let thumbnail = '';
            
            item.innerHTML = `
                ${thumbnail}
                <div class="video-info">
                    <span class="title">${video.title}</span>
                    <span class="date">${new Date(video.date_recorded).toLocaleDateString(undefined, {dateStyle: 'full'})}</span>
                </div>
                <span class="length">${secondsToTime(video.duration)}</span>
            `;
            
            this.$playlist.appendChild(item);
        });
    },

    play_video(event) {
        if (!window.App || !window.App.MediaPlayer) {
            console.error("MediaPlayer not available");
        }

        const video = event.target;
        const position = parseInt(video.dataset.position);
        const player = window.App.MediaPlayer;

        player.loadPlaylist(this.videos, position);

        document.getElementById('vod-player').classList.remove('hidden');
        player.teleport('video-slot');

        document.getElementById('main-hls-video').play();

        this.$playlist.querySelectorAll('.video').forEach(el => el.classList.remove('active'));
        video.classList.add('active');
    },

    _bind_play_video: null,

    onMount() {
        this.$unauthorised = document.getElementById('vod-unauthorised');
        this.$authorised = document.getElementById('vod-authorised');
        this.$playlist = document.getElementById('vod-playlist');

        const services = store.get('services');
        this.authorised = services.includes(2);

        if (this.authorised) {
            this.$authorised.classList.remove('hidden');

            if (window.App && window.App.MediaPlayer && window.App.MediaPlayer.service() === 'vod') {
                document.getElementById('vod-player').classList.remove('hidden');
            }
            
            api.get({
                url: '/vod/playlist',
                success: (data) => {
                    this.videos = data.videos;
                    this.render_playlist();
                },
                error: (err) => {
                    console.error("Failed to load VOD videos", err);
                    this.$playlist.innerHTML = '<p class="center">Failed to load videos. Please try again later.</p>';
                }
            });

            this._bind_play_video = (event) => {
                if (event.target.classList.contains('video')) {
                    this.play_video(event);
                }
            };
            this.$playlist.addEventListener('click', this._bind_play_video)
        } else {
            this.$unauthorised.classList.remove('hidden');
        }
    },

    onUnmount() {
        if (window.App && window.App.MediaPlayer && window.App.MediaPlayer.service() === 'vod') {
            window.App.MediaPlayer.resetLocation();
        }

        if (this.$playlist && this._bind_play_video) this.$playlist.removeEventListener('click', this._bind_play_video);
    }
};
